import $foreign from "./foreign.cjs";
var fromCharCode = $foreign.fromCharCode;
var toCharCode = $foreign.toCharCode;
export { fromCharCode, toCharCode };
